import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSync16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowSync16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.1 3.799c-2.37-.635-4.687.695-5.32 3.062a1 1 0 0 1-.032.084h2.248a.5.5 0 1 1 0 1h-4v-4a.5.5 0 1 1 1 0v2.093c.978-2.548 3.656-3.93 6.362-3.205a5.4 5.4 0 0 1 2.346 1.305.5.5 0 0 1-.69.724A4.4 4.4 0 0 0 9.1 3.8m-2.2 8.353c2.369.634 4.686-.695 5.32-3.062a.5.5 0 0 1 .03-.085h-2.247a.5.5 0 1 1 0-1h4v4a.5.5 0 1 1-1 0V9.912c-.978 2.548-3.656 3.93-6.362 3.205a5.4 5.4 0 0 1-2.346-1.305.5.5 0 1 1 .69-.724c.512.488 1.16.861 1.915 1.064"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowSync16);
